import { Dispatch, SetStateAction } from 'react';
import { UpdateReport } from 'src/api';
import { UserType } from 'src/graphql';
import { AddUserModal } from '../AddUserModal/AddUserModal';

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  reportID: string;
  currentReport: UpdateReport | null;
  updateReport: (reportID: string, report: UpdateReport) => void;
  isUpdateRelationshipToOrganisationEnabled?: boolean;
}

export const AddReporterModal = (props: Props) => {
  const updateReporter = ({
    internalUser,
    selectedUser,
    email,
    name,
    relationshipToCompany,
  }: {
    internalUser: boolean;
    selectedUser: UserType;
    email: string;
    name: string;
    relationshipToCompany?: { label: string; value: number };
  }) => {
    if (internalUser) {
      props.updateReport(props.reportID, {
        ...props.currentReport,
        relationshipToCompany: props.isUpdateRelationshipToOrganisationEnabled
          ? relationshipToCompany?.value
          : null,
        user: `${selectedUser?.id}`,
      });
    } else {
      props.updateReport(props.reportID, {
        ...props.currentReport,
        relationshipToCompany: props.isUpdateRelationshipToOrganisationEnabled
          ? relationshipToCompany?.value
          : null,
        userUpdates: {
          email,
          name,
          relationshipToCompany: relationshipToCompany?.value,
        },
      });
    }
    props.setOpen(false);
  };

  return (
    <AddUserModal
      {...props}
      showOnlyCM={false}
      title="Add Reporter"
      subTitle="Reporter Name"
      addUserText="Add Reporter from:"
      updateData={updateReporter}
      buttonText="Add Reporter"
      data-testid="reporter"
      onlyAppUsers={false}
      allowUpdatingInternalUserRelationshipToOrg={
        props.isUpdateRelationshipToOrganisationEnabled
      }
    />
  );
};
